/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { colors, devices } from '../../config/theme'

const style = {
  upcomingVisit: {
    color: colors.blue,
    fontWeight: '500 !important',
    [devices.mobile]: {
      maxWidth: '260px',
      fontSize: '21px',
      textAlign: 'center',
      fontWeight: '500 !important',
      lineHeight: '30px',
      margin: '5px 0 0 0 !important'
    }
  },

  base: {
    width: '100%',
    height: '100%',
    [devices.desktop]: {
      '& h4': {
        maxWidth: '510px',
        fontSize: '16px'
      },
      '& .greatTitle': {
        fontWeight: '500 !important',
        fontSize: '16px'
      }
    },
    [devices.mobile]: {
      '& .greatTitle': {
        margin: '5px !important',
        fontSize: '16px'
      }
    }
  },

  msgContainer: {
    [devices.mobile]: {
      // display: 'flex',
      // flexDirection: 'column',
      height: '100% !important',
      // height: 'calc(100% - 65px)',
      padding: '0 !important'
    }
  },

  topContainer: {
    [devices.mobile]: {
      height: '51%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },

  bottomContainer: {
    [devices.mobile]: {
      height: '49%',
      backgroundColor: '#f4f4f4',
      padding: '25px 40px 110px 40px',
      '& h4': {
        fontSize: '16px',
        lineHeight: '25px'
      }
    }
  }
}

export default style
